import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography
} from '@material-ui/core'
import { Stack } from '@mui/material'
import { EditOutlined as Edit } from '@material-ui/icons'
import React, { useState } from 'react'
import TemplateForm from 'views/admin/settings/SettingForm/TemplateForm'
import RichTextRenderer from 'components/RichTextRenderer'

export const TemplateCard = ({ id, template, onSaveTemplate, isLoading = false }) => {
  const classes = useStyles()
  const [isOpenModal, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const onSubmit = (values) => {
    onSaveTemplate && onSaveTemplate(values, handleCloseModal)
  }

  return (
    <>
      <Card className={classes.card} variant="outlined" id={id}>
        <CardContent className={classes.content}>
          <Box className={classes.header}>
            <Box className={classes.title}>
              <Typography className={classes.titleText}>{template?.name}</Typography>
              <Button
                startIcon={<Edit />}
                variant="contained"
                color="primary"
                onClick={handleOpenModal}>
                Edit
              </Button>
            </Box>
          </Box>
          <Stack flex={1} gap={1} justifyContent="space-between" mt={1.4}>
            <Box className={classes.subject}>
              <Typography className={classes.subjectTitle}>Email Subject:</Typography>
              <Typography className={classes.greyText}>{template?.subject || 'N/A'}</Typography>
            </Box>
            <Box sx={{ mt: 1 }}>
              <RichTextRenderer htmlContent={template?.body || ''} />
            </Box>
          </Stack>
        </CardContent>
      </Card>
      <Dialog fullWidth maxWidth="xl" open={isOpenModal}>
        <DialogTitle>
          <Typography className={classes.dialogTitle}>{template?.name}</Typography>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <TemplateForm
            initialValues={{
              subject: template?.subject || '',
              body: template?.body || ''
            }}
            onCancel={handleCloseModal}
            onSubmit={onSubmit}
            isLoading={isLoading}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default TemplateCard

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: '12px'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: '16px'
  },
  modalContent: {
    marginTop: '1rem'
  },
  header: {
    background: '#CAEDF5',
    padding: '12px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    p: {
      color: 'rgb(66, 66, 66)'
    }
  },
  titleText: {
    letterSpacing: '0.8px',
    fontWeight: 600,
    fontSize: '16px'
  },
  subject: {
    display: 'flex',
    gap: 4,
    alignItems: 'center'
  },
  subjectTitle: {
    fontWeight: 'bold'
  },
  greyText: {
    color: '#606060'
  },
  emailBody: {
    color: '#606060',
    whiteSpace: 'pre-wrap',
    lineHeight: '18px'
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: '18px',
    color: '#606060',
    letterSpacing: '0.8px'
  }
}))
